import { useCallback, useEffect, useMemo, useRef, useState, } from "react";
import { createPortal } from "react-dom";
import { Container } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useLoader } from "../../../context/LoaderContext";
import NpaListSection from "./NpaPublicListSection";
import NpaAddImpExprtBtn from "./NpaAddImpExprtBtn";
import ConfirmModal from "../../../components/withModal/ConfirmModal";
import {
  InformationCircleIcon,
  NpaPropertyIcon,
  NpaPublicProIcon,
} from "../../../assets/icons";
import {
  changePublicPropertyStatus,
  changePublicStatus,
  changeStatus,
  deleteAllProperty,
  deletePublicProperty,
  fetchPropertyStats,
  npaAllProperties,
} from "../../../redux/slice/allPropertiesSlice";
import { fetchPropertyFields } from "../../../redux/slice/fieldsSlice";
import { useToast } from "../../../context/TostContext";
import FilterModal from "../../../components/FilterModal/FilterModal";
import { usePermission } from "../../../hooks/usePermission";
import { TabCard } from "../../../components/custom-card/Cards";

const MODULE_SLUG = "properties";

// import { allUserList } from "../../../redux/slice/userSlice";

export default function List() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { setLoading } = useLoader();
  const headerPortalTarget = document.getElementById("header-portal-target");

  const headerContent = (
    <div className="d-flex align-items-center justify-content-between w-100">
      <h4 className="fw-semibold mb-0 text-primary fs-lg">
        <span className="text-muted fw-normal">Broker CRM / </span>Properties
      </h4>
    </div>
  );
  const toast = useToast();
  const { hasPermission } = usePermission();

  const canUpdate = hasPermission(MODULE_SLUG, "update");
  const canDelete = hasPermission(MODULE_SLUG, "delete");
  const canExport = hasPermission(MODULE_SLUG, "export");
  const canCreate = hasPermission(MODULE_SLUG, "create");
  // List Dropdown
  const [openDropdown, setOpenDropdown] = useState(null);
  const handleToggleDropdown = (dropdownId) => {
    setOpenDropdown((prev) => (prev === dropdownId ? null : dropdownId));
  };
  // Pagination

  // let savePage = sessionStorage.getItem("currentPageNo");
  // let final = parseInt(savePage, 10);
  // const [currentPage, setCurrentPage] = useState(final ? final : 1);
  const [currentPage, setCurrentPage] = useState(() => {
    const savedPage = sessionStorage.getItem("allPublicProperties_page");
    if (savedPage) return parseInt(savedPage, 10);
    return 1;
  });
  // Delete Property, Modal state
  const [confirmModalConfig, setConfirmModalConfig] = useState({
    isOpen: false,
    title: "",
    message: "",
    onConfirm: () => { },
    confirmText: "Yes",
    cancelText: "No",
    className: "confirm-modal",
    icon: null,
  });
  // Card Status
  // const DEFAULT_STATUS = ""; // empty string = All Property

  // 2) Use it for initial state
  // const [cardStatus, setCardStatus] = useState(DEFAULT_STATUS);
  const [cardStatus, setCardStatus] = useState(() => {
    return sessionStorage.getItem("allPublicProperties_cardStatus") || "";
  });
  // Add or Edit Form
  const [isEdit, setIsEdit] = useState(false);
  // Filter Modal State
  const [filterModal, setFilterModal] = useState(false);
  // search & Filter
  const [filterValues, setFilterValues] = useState(() => {
    const searchValue = sessionStorage.getItem("allPublicProperties_searchQuery") || "";

    let filValues = {};
    const stored = sessionStorage.getItem("allPublicProperties_filterValues");
    if (stored) {
      try {
        filValues = JSON.parse(stored);
      } catch (e) {
        console.error("Failed to parse filter values", e);
      }
    }

    return {
      search: searchValue,
      asset: filValues.asset || "",
      property: filValues.property || [],
      possession: filValues.possession || [],
      city: filValues.city || "",
      reservePrice: filValues.reservePrice || "",
      transaction: filValues.transaction || "",
      status: "",
      land_types: "",
    }
  });
  console.log("npaAllFilter123", filterValues);
  // Open Modal for Import
  const [searchQuery, setSearchQuery] = useState(() => {
    return sessionStorage.getItem("allPublicProperties_searchQuery") || "";
  });
  const isInitialLoadRef = useRef(true);
  const searchTimeout = useRef(null);
  // Options for filters dropdown

  //  const [dropdownData, setDropdownData] = useState({
  //     propertyTypes: [],
  //     assetCategories: [],
  //     possessionTypes: [],
  //     auctionTypes: [],
  //   });

  // console.log("dropdownData",dropdownData);
  // console.log("cardStatus",cardStatus);

  const { propertyFields, isLoading } = useSelector((state) => state.fields);
  const count = useSelector((state) => state.allProperties.propertyStats);
  useEffect(() => {
    dispatch(fetchPropertyFields()); // Fetch the dropdown fields when the component mounts
  }, [dispatch]);

  // Map property types to Select options
  const propertyTypeOptions = (() => {
    const list = propertyFields?.property_types ?? [];
    const withLand = list?.includes("Land") ? list : ["Land", ...list];
    return withLand.map((type) => ({ value: type, label: type }));
  })();


  // pagination

  const [
    limit,
    setLimit
  ] = useState(() => {
    const savedLimit = sessionStorage.getItem("allPublicProperties_limit");
    if (savedLimit) return JSON.parse(savedLimit);
    return { value: 10, label: 10 };
  });

  // Land Types options
  const landTypeOptions = propertyFields?.land_types?.map((t) => ({
    value: t,
    label: t,
  }));

  const transactionTypeOptions =
    propertyFields?.transaction_types?.map((type) => ({
      value: type?.id || type?._id || type,
      label: type?.name || type,
    }));

  const possessionOption = propertyFields?.possessions?.map(
    (type) => ({
      value: type,
      label: type,
    })
  );

  const statusOptions = propertyFields?.statuses?.map((type) => ({
    value: type,
    label: type,
  }));


  // ID will store in this state if we select any user from dropdown

  const properties = useSelector(
    (state) => state?.allProperties?.property
  );

  const totalProperties = properties?.meta?.total;
  const NpaPropertiesCard = [
    {
      id: 1,
      total: count?.data?.total_properties || 0,
      title: "All Property",
      icon: <NpaPropertyIcon size={24} />,
      status: "",
      iconClassName: "icon-secondary",
    },
    {
      id: 2,
      total: count?.data?.total_public_properties || 0,
      title: "Public Property",
      icon: <NpaPublicProIcon />,
      status: "public",
      iconClassName: "icon-primary",
    },
  ];

  const handleCardClick = (status) => {
    setCardStatus(status);
    setCurrentPage(1);
  };

  // const searchTimeout = useRef(null); // To store the timeout ID

  // Debounced Search Handler
  // const handleSearch = useCallback(() => {
  //   if (!searchQuery) {
  //     // Do not call API if searchQuery is empty
  //     return;
  //   }

  //   if (searchTimeout.current) {
  //     clearTimeout(searchTimeout.current); // Clear the previous timeout if the user is still typing
  //   }

  //   searchTimeout.current = setTimeout(() => {
  //     console.log("gauravss");

  //     dispatch(npaAllProperties({
  //       search: filterValues?.search,
  //       page: currentPage,
  //       limit: limit?.value,
  //       status: cardStatus,
  //       asset_category: filterValues?.asset,
  //       property_type: filterValues?.property,
  //       possession_type: filterValues?.possession,
  //       city_town: filterValues?.city,
  //       reserve_price: filterValues?.reservePrice,
  //     }));
  //   }, 1000); // 1000ms delay to wait before calling API
  // }, [filterValues, cardStatus, currentPage, searchQuery, dispatch, limit?.value]);

  // // Trigger the API call whenever filterValues or searchQuery changes
  // useEffect(() => {
  //   if (searchQuery) {
  //     handleSearch();
  //   }
  //   return () => clearTimeout(searchTimeout.current); // Clean up timeout on unmount or change
  // }, [handleSearch, searchQuery]);

  // A ref to hold the debounce timer

  // Debounce effect
  useEffect(() => {
    // Clear any previous timeout to reset the timer
    if (searchTimeout.current) {
      clearTimeout(searchTimeout.current);
    }

    // Set a new timeout
    searchTimeout.current = setTimeout(() => {
      // Update the official filter state with the debounced query
      setFilterValues((prev) => ({
        ...prev,
        search: searchQuery,
      }));
    }, 500); // 500ms debounce delay

    // Cleanup function to clear the timeout if the component unmounts
    return () => clearTimeout(searchTimeout.current);
  }, [searchQuery]);

  const getAllNpaProperties = useCallback(() => {
    if (isInitialLoadRef.current) {
      setLoading(true);
    }

    // setLoading(true);

    // Combine filters into one request

    let requestParams = {
      search: filterValues?.search,
      page: currentPage,
      limit: limit?.value,
      status: filterValues?.status,
      property_type: filterValues?.property,
      possession_type: filterValues?.possession,
      transaction_type: filterValues?.transaction,
      city_town: filterValues?.city,
      reserve_price: filterValues?.reservePrice,
      land_types: filterValues?.land_types,
    };

    // Only add is_public to the request if cardStatus is "public"
    if (cardStatus === "public") {
      requestParams.is_public = true;
    }

    // Make the API call with the dynamic parameters

    dispatch(npaAllProperties(requestParams))
      .then(() => {
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
      })
      .finally(() => {
        if (isInitialLoadRef.current) {
          setLoading(false);
          isInitialLoadRef.current = false;
        }
      });
    console.log("filterValuesabc", filterValues);

    sessionStorage.setItem("allPublicProperties_limit", JSON.stringify(limit));
    sessionStorage.setItem("allPublicProperties_page", currentPage.toString());
    sessionStorage.setItem("allPublicProperties_cardStatus", cardStatus);
    sessionStorage.setItem("allPublicProperties_searchQuery", filterValues.search);
    sessionStorage.setItem("allPublicProperties_filterValues", JSON.stringify(filterValues));
    console.log("sesstionstorage", sessionStorage.getItem("allPublicProperties_filterValues"));
  }, [
    dispatch,
    setLoading,
    // filterValues?.property,
    // filterValues?.possession,
    // filterValues?.city,
    // filterValues?.reservePrice,
    // filterValues?.transaction,
    limit,
    currentPage,
    // filterValues?.status,
    cardStatus,
    filterValues,
    // filterValues?.search,
    // filterValues?.land_types,
  ]);

  useEffect(() => {
    // setSearchQuery(""); // Removed to persist search state from sessionStorage
    isInitialLoadRef.current = true;
  }, []);

  useEffect(() => {
    getAllNpaProperties();
  }, [getAllNpaProperties]);

  useEffect(() => {
    dispatch(fetchPropertyStats());
  }, [dispatch])

  // useEffect(() => {
  //   dispatch(reqToGetFilterData({}));
  //   dispatch(propertyTypesDropdown({})).then((res) => {
  //     if (res?.payload?.success === true) {
  //       const formattedData = {
  //         propertyTypes: res?.payload?.data?.propertyTypes?.map(item => item?.name),
  //         assetCategories: res?.payload?.data?.assetCategories?.map(item => item?.name),
  //         possessionTypes: res?.payload?.data?.possessionTypes?.map(item => item?.name),
  //         auctionTypes: res?.payload?.data?.auctionTypes.map(item => item?.name),
  //       };
  //       setDropdownData(formattedData);
  //     }
  //   });
  // }, [dispatch]);


  const getCustomerActions = (item) => {
    const actions = [
      {
        title: "View",
        handler: () => {
          navigate(
            `/broker-crm/properties/property-details/${item.id}`,
            {
              state: {
                id: item?.id,
                currentPage,
                ...(cardStatus === "public" ? { is_public: true } : {}),
              },
            }
          )
        }
      },
    ];

    if (canUpdate) {
      actions.push(
        {
          title: "Edit",
          handler: () => handleEditBtn(item),
        },
        {
          title: item.status === "Open" ? "Close" : "Open",
          handler: () => handlerTogglePropertyStatus(item),
        },
        {
          title: item.is_public ? "Unpublish" : "Publish",
          handler: () => handlerTogglePublicStatus(item),
        }
      );
    }

    if (canDelete) {
      actions.push({
        title: "Delete",
        handler: () => handlerDeleteProperty(item),
      });
    }

    return actions;
  };

  const handlerTogglePropertyStatus = (item) => {
    const newStatus = item.status === "Open" ? "Close" : "Open";
    setLoading(true);

    const actionToDispatch =
      cardStatus === "public"
        ? changePublicPropertyStatus({ id: item.id, status: newStatus })
        : changeStatus({ id: item.id, status: newStatus });

    dispatch(actionToDispatch)
      .unwrap()
      .then(() => {
        toast.success("Property status updated successfully");
        // getAllNpaProperties(); // Removed to manage state locally
        dispatch(fetchPropertyStats());
      })
      .catch((err) => {
        toast.error(err?.message || (typeof err === 'string' ? err : "Failed to update status"));
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handlerTogglePublicStatus = (item) => {
    if (cardStatus === "public" && item.is_public) {
      setConfirmModalConfig({
        isOpen: true,
        title: "Confirm Unpublish?",
        message: "Are you sure you want to unpublish this property? It will be removed from the public list but will remain in your main property list.",
        confirmText: "Unpublish",
        cancelText: "Cancel",
        className: "confirm-modal",
        onConfirm: () => handleConfirmUnpublish(item),
        icon: (<InformationCircleIcon size={48} />)
      });
      return;
    }

    const newPublicStatus = !item.is_public;
    setLoading(true);

    const targetId = cardStatus === "public" ? (item.property_id || item.id) : item.id;

    dispatch(changePublicStatus({ id: targetId, is_public: newPublicStatus }))
      .unwrap()
      .then(() => {
        toast.success("Property visibility updated successfully");
        dispatch(fetchPropertyStats());
      })
      .catch((err) => {
        toast.error(err?.message || (typeof err === 'string' ? err : "Failed to update visibility"));
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleConfirmUnpublish = (item) => {
    if (!item?.id) return;
    setLoading(true);

    dispatch(deletePublicProperty(item.id))
      .unwrap()
      .then(() => {
        toast.success("Property unpublished successfully");
        dispatch(fetchPropertyStats());
      })
      .catch((err) => {
        toast.error(err?.message || (typeof err === 'string' ? err : "Failed to unpublish property"));
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handlerDeleteProperty = (item) => {
    setConfirmModalConfig({
      isOpen: true,
      title: "Delete Property",
      message: "Are you sure you want to delete this Property?",
      confirmText: "Delete",
      cancelText: "Cancel",
      className: "confirm-modal",
      onConfirm: () => handleConfirmDelete(item),
    });
  };

  // Main Handler for Deleting NPA Properties
  const handleConfirmDelete = (item) => {
    if (!item?.id) return;
    setLoading(true);

    const actionToDispatch =
      cardStatus === "public"
        ? deletePublicProperty(item.id)
        : deleteAllProperty({ id: item.id });

    dispatch(actionToDispatch)
      .unwrap()
      .then(() => {
        toast.success("Property deleted successfully");
        dispatch(fetchPropertyStats());
      })
      .catch((err) => {
        toast.error(err?.message || (typeof err === 'string' ? err : "Failed to delete Property"));
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleEditBtn = (item) => {
    setIsEdit(true);

    // Linked public property: has a property_id pointing to the original private property
    const isLinkedPublic = cardStatus === "public" && !!item.property_id;
    // Standalone public property: created directly without a private property link
    const isStandalonePublic = cardStatus === "public" && !item.property_id;

    // For linked public, edit the original private property using its ID
    const editId = isLinkedPublic ? item.property_id : item.id;

    navigate(`/broker-crm/properties/edit/${editId}`, {
      state: {
        item,
        isEdit: true,
        isPublicProperty: isStandalonePublic,
      },
    });
  };



  const handleClearFilters = () => {
    setFilterValues({
      asset: "",
      property: [], // ⟵ array cleared
      possession: [], // ⟵ array cleared
      city: "",
      reservePrice: "",
      transaction: [], // ⟵ array cleared
      land_types: "",
      status: "",
      search: filterValues?.search ? filterValues?.search : "",
    });
    setFilterModal(false);
  };

  const paginationConfig = useMemo(() => ({
    currentPage,
    totalPages: Math.ceil(totalProperties / limit?.value) || 1,
    total: totalProperties || 0,
    onPageChange: (page) => setCurrentPage(page),
    pageSize: limit?.value,
    setPageSize: (size) => setLimit({ value: size, label: size }),
    setCurrentPage
  }), [currentPage, totalProperties, limit]);

  return (
    <>
      {headerPortalTarget && createPortal(headerContent, headerPortalTarget)}


      <Container fluid className="px-0">
        <div className="grid gap-4">
          {NpaPropertiesCard?.map((item, i) => (
            <TabCard
              key={i}
              className="g-col-4 g-col-xxl-3"
              count={item?.total}
              title={item?.title}
              icon={item?.icon}
              iconClassName={item?.iconClassName}
              active={item.status === cardStatus}
              onClick={() => handleCardClick(item?.status)}
            />
          ))}
        </div>

        <div className="bg-white rounded-2 overflow-hidden common-shadow mt-4">
          {/* Export, Import, Add Btn Section */}
          <NpaAddImpExprtBtn
            navigate={navigate}
            filterValues={filterValues}
            setFilterModal={setFilterModal}
            setFilterValues={setFilterValues}
            setCurrentPage={setCurrentPage}
            searchQuery={searchQuery}
            setSearchQuery={setSearchQuery}
            canCreate={canCreate}
            canExport={canExport}
            cardStatus={cardStatus}
          />

          {/* List Section */}
          <NpaListSection
            isEdit={isEdit}
            isLoading={isLoading}
            data={properties?.data}
            navigate={navigate}
            currentPage={currentPage}
            openDropdown={openDropdown}
            handleEditBtn={handleEditBtn}
            getCustomerActions={getCustomerActions}
            handleToggleDropdown={handleToggleDropdown}
            isPublicView={cardStatus === "public"}
            searchQuery={searchQuery}
            filterValues={filterValues}
            canUpdate={canUpdate}
            canDelete={canDelete}
            pagination={paginationConfig}
          />
        </div>
      </Container>

      {/* Delete Modal */}
      <ConfirmModal
        isOpen={confirmModalConfig.isOpen}
        onClose={() => setConfirmModalConfig((prev) => ({ ...prev, isOpen: false }))}
        title={confirmModalConfig.title}
        message={confirmModalConfig.message}
        onConfirm={confirmModalConfig.onConfirm}
        confirmText={confirmModalConfig.confirmText}
        cancelText={confirmModalConfig.cancelText}
        className={confirmModalConfig.className}
        icon={confirmModalConfig.icon}
      />

      {/* Filter Modal */}
      <FilterModal
        isOpen={filterModal}
        size="lg"
        onClose={() => setFilterModal(false)}
        filterValues={filterValues}
        setFilterValues={setFilterValues}
        setCurrentPage={setCurrentPage}
        propertyOptions={propertyTypeOptions}
        possessionOptions={possessionOption}
        transactionOptions={transactionTypeOptions}
        statusOptions={statusOptions}
        landTypeOptions={landTypeOptions}
        onClear={handleClearFilters}
      />



    </>
  );
}
